// extracted by mini-css-extract-plugin
export default {"horizontalSeparationLine":"SeparationLine_horizontalSeparationLine__xqiZE","verticalSeparationLine":"SeparationLine_verticalSeparationLine__roWL+"};